enum types {
	SET_LAYOUT = 'SET_LAYOUT',
	SET_LAYOUT_SIDEBAR = 'SET_LAYOUT_SIDEBAR',
	SET_LAYOUT_UNFOLDABLE = 'SET_LAYOUT_UNFOLDABLE',

	// Category
	FETCH_MAIN_CATEGORY_START = 'FETCH_MAIN_CATEGORY_START',
	FETCH_MAIN_CATEGORY_SUCCESS = 'FETCH_MAIN_CATEGORY_SUCCESS',
	FETCH_MAIN_CATEGORY_FAILURE = 'FETCH_MAIN_CATEGORY_FAILURE',

	// Category - Buduce Products V2
	GET_ALL_PRODUCTS_FETCH = 'GET_ALL_PRODUCTS_FETCH',
	GET_ALL_PRODUCTS_SUCCESS = 'GET_ALL_PRODUCTS_SUCCESS',
	GET_ALL_PRODUCTS_FAILURE = 'GET_ALL_PRODUCTS_FAILURE',

	GET_PRODUCT_TREE_SUCCESS = 'GET_PRODUCT_TREE_SUCCESS',

	SET_PRODUCT_ACTIVE_ITEM = 'SET_PRODUCT_ACTIVE_ITEM',
	RESET_PRODUCT_ACTIVE_ITEM = 'RESET_PRODUCT_ACTIVE_ITEM',

	SET_FILTER_SEARCH_ITEM = 'SET_FILTER_SEARCH_ITEM',

	// Product
	PRODUCT_DETAIL_FETCH_SUCCESS = 'PRODUCT_DETAIL_FETCH_SUCCESS',
	PRODUCT_DETAIL_FETCH_FAILURE = 'PRODUCT_DETAIL_FETCH_FAILURE',
	PRODUCT_DETAIL_RESET = 'PRODUCT_DETAIL_RESET',

	//Modals
	SET_LOGIN_MODAL = 'SET_LOGIN_MODAL',
	CLOSE_LOGIN_MODAL = 'CLOSE_LOGIN_MODAL',
	SET_CHANGE_ADDRESS_MODAL = 'SET_CHANGE_ADDRESS_MODAL',
	CLOSE_CHANGE_ADDRESS_MODAL = 'CLOSE_CHANGE_ADDRESS_MODAL',
	SET_CHANGE_INVOICE_MODAL = 'SET_CHANGE_INVOICE_MODAL',
	CLOSE_CHANGE_INVOICE_MODAL = 'CLOSE_CHANGE_INVOICE_MODAL',
	SET_CHANGE_DELIVERY_CALENDAR_MODAL = 'SET_CHANGE_DELIVERY_CALENDAR_MODAL',
	CLOSE_CHANGE_DELIVERY_CALENDAR_MODAL = 'CLOSE_CHANGE_DELIVERY_CALENDAR_MODAL',
	SET_MODAL_FILTER = 'SET_MODAL_FILTER',
	CLOSE_MODAL_FILTER = 'CLOSE_MODAL_FILTER',

	//Login

	LOGIN_SUCCESS = 'LOGIN_SUCCESS',
	LOGIN_FAILURE = 'LOGIN_FAILURE',

	LOGOUT = 'LOGOUT',

	REFRESH_TOKEN_START = 'auth/refresh/token/start',
	REFRESH_TOKEN_SUCCESS = 'auth/refresh/token/success',
	REFRESH_TOKEN_FAILURE = 'auth/refresh/token/failure',

	// User
	USER_REGISTRATION_SUCCESS = 'USER_REGISTRATION_SUCCESS',

	// PRODUCTS FILTERS
	PRODUCTS_FILTER_INPUT_TEXT = 'PRODUCTS_FILTER_INPUT_TEXT',
	SET_PRODUCTS_FILTER = 'SET_PRODUCTS_FILTER',
	SET_PRODUCTS_FILTER_INPUT = 'SET_PRODUCTS_FILTER_INPUT',
	SET_PRODUCTS_FILTER_MODAL = 'SET_PRODUCTS_FILTER_MODAL',
}

export interface IAction {
	meta?: string;
	payload?: any;
	type: types;
}

export default types;
